import React from "react";

import ReactDOM from "react-dom";

import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

export const Loader = ({ open, message = false, zIndex = 130000002 }) => {
  return (
    <>
      {open
        ? ReactDOM.createPortal(
            <>
              <Backdrop
                id="loader-backdrop"
                sx={{ color: "#fff", zIndex }}
                open={open}
              >
                <CircularProgress color="inherit" />
                &nbsp;&nbsp;&nbsp;{message || "Please wait.."}
              </Backdrop>
            </>,
            document.body,
          )
        : null}
    </>
  );
};
